<template>
	<div class="full">
		<div class="module_container full" style="position: relative;">
			<el-container class="full" style="position: relative;">
				<el-container class="full" style="position: relative;">
					<el-header height="80px" class="head">
						<el-row :gutter="20">
							<el-col :span="6">
								<div>
									<el-statistic group-separator="," :precision="2" :value="amount"
										title="赔付总金额"></el-statistic>
								</div>
							</el-col>
							<el-col :span="6">
								<div>
									<el-statistic group-separator="," :precision="0" :value="ordernum"
										title="总笔数"></el-statistic>
								</div>
							</el-col>
						</el-row>
					</el-header>
					<el-main class="main flex" style="flex: 1;">
						<div style="position: relative;width: 100%;flex: 1;height: 70%;">
							<vxe-grid class="full" ref="compensation_list" v-if="list_gridOptions"
								v-bind="list_gridOptions"
								@toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
						</div>
						<div style="position: relative;width: 100%;height:30%;">
							<chart ref="chart" />
						</div>
					</el-main>
				</el-container>
			</el-container>
		</div>
		<statistics :groupbywarehouse="groupbywarehouse" ref="compensationStatistics" />
		<reasonForm :row="currentrow" ref="reasonForm" @success="editSuccess" />
	</div>
</template>
<style scoped>
	.module_container {
		box-sizing: border-box;
		padding-bottom: 10px;
	}

	.head {
		padding: 10px 0;
		border-bottom: 1px solid rgb(220, 223, 230);
	}

	.aside {
		border-right: 1px solid rgb(220, 223, 230);
		box-sizing: border-box;
		padding-bottom: 100px;
	}

	.main {
		position: relative;
		width: 100%;
		height: 100%;
		padding: 5px;
		box-sizing: border-box;
		flex-direction: column;
		overflow: hidden;

	}

	.group {
		margin: 10px 0px;
		width: 100%;
		margin-left: 10px;
	}
</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import statistics from './statistics/index.vue'
	import chart from './lib/chart.vue'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	import reasonForm from './form/reason.vue'
	export default {
		mixins: [listMixins],
		name: 'compensationIndex',
		props: {

		},
		data() {
			return {
				amount: 0,
				ordernum: 0,
				moduleName: 'compensation',
				windowName: '模块名称',
				windowType: 'modal',
				groupbywarehouse:null,
				currentrow:null,
				list_formConfig: [{
					field: 'shopname',
					title: '店铺名称',
					itemRender: {
						name: '$select',
						props: {
							emptyoption: false,
							selectoptions: [],
							multiple:true
						}
					}
				}, {
					field: 'mainOrderId',
					title: '业务编号',
					itemRender: {
						name: '$input'
					}
				}, {
					field: 'warehouse',
					title: '发货仓库',
					itemRender: {
						name: '$input'
					}
				}, 
				// {
				// 	field: 'violationType',
				// 	title: '业务类型',
				// 	itemRender: {
				// 		name: '$select',
				// 		props:{
				// 			emptyoption:false,
				// 			multiple:true,
				// 			selectoptions:[{
				// 				label:'PBC延迟发货（天猫）',
				// 				value:'PBC延迟发货（天猫）',
				// 			},{
				// 				label:'PBC延迟发货（淘宝）',
				// 				value:'PBC延迟发货（淘宝）',
				// 			},{
				// 				label:'售后退款交易赔付',
				// 				value:'售后退款交易赔付',
				// 			},{
				// 				label:'物流停滞自动赔付',
				// 				value:'物流停滞自动赔付',
				// 			}]
				// 		}
						
				// 	}
				// }, 
				{
					field: 'time',
					title: '处置时间',
					resetValue: [
						window.systemMethods.timestampToMonth(new Date().getTime()),
						window.systemMethods.timestampToMonth(new Date().getTime(), 'end')
					],
					itemRender: {
						name: '$datePicker',
						defaultValue: [
							window.systemMethods.timestampToMonth(new Date().getTime()),
							window.systemMethods.timestampToMonth(new Date().getTime(), 'end')
						]
					}
				}, {
					field: 'reason',
					title: '赔付原因',
					itemRender: {
						name: '$select',
						props: {
							emptyoption:false,
							allowCreate:true,
							selectoptions: [{
								label:'物流轨迹异常',
								value:'物流轨迹异常'
							},{
								label:'物流轨迹超时',
								value:'物流轨迹超时'
							},{
								label:'虚假发货',
								value:'虚假发货'
							},{
								label:'延迟发货',
								value:'延迟发货'
							},{
								label:'运费',
								value:'运费'
							},{
								label:'缺货',
								value:'缺货'
							}]
						}
					}
				}, {
					align: 'left',
					span: 24,
					itemRender: {
						name: '$tableformbutton',
						props: {
							table: this
						}
					}
				}],
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			list_init() {
				this.$api.compensation.initform().then((res) => {
					let list_gridOptions = this.list_getOption()
					this.list_beforeCreateGrid(list_gridOptions)
					this.list_gridOptions = list_gridOptions
					this.list_formConfig.forEach((item) => {
						if (item.field == 'shopname') {
							let selectoptions = []
							for (let i in res.shopoption) {
								selectoptions.push({
									value: res.shopoption[i],
									label: res.shopoption[i]
								})
							}
							item.itemRender.props.selectoptions = selectoptions
						}
					})
				})
			},
			list_beforeCreateGrid(gridOptions) {
				gridOptions.id = this.moduleName
				gridOptions.formConfig.span = 4
				gridOptions.pagerConfig.enabled = true
				gridOptions.pagerConfig.pageSizes = [10, 20, 50, 100, 200, 5000]
				gridOptions.toolbarConfig.buttons = [{
					name: '导出',
					status: 'success',
					code: 'export'
				}, {
					name: '统计',
					status: 'warning',
					code: 'static'
				}]
				gridOptions.columns = [{
						field: 'shopname',
						title: '店铺名称',
					},
					{
						field: 'mainOrderId',
						title: '业务编号'
					},
					// {
					// 	field: 'violationType',
					// 	title: '业务类型',
					// },
					{
						field: 'warehouse',
						title: '发货仓库',
					},
					{
						field: 'fee',
						title: '赔付金额',
					},
					{
						field: 'time',
						title: '处置时间',
						formatter: ({
							cellValue
						}) => {
							return window.systemMethods.timestampToDate(cellValue)
						}
					},
					{
						field: 'reason',
						title: '赔付原因',
					},
					{
						field: 'customremark',
						title: '原因备注',
					},
					{
						field: 'img_file',
						title: '附件',
						slots:{
							default({row,column}){
								return <upload value={row[column.field]?row[column.field]:[]} readonly />
							}
						}
					},
					{
						title: '操作',
						fixed: "right",
						align: 'center',
						width: 65,
						slots: {
							default: ({row}) => {
								return [<el-button type = "text" size = "mini" onClick = {() => {this.edit(row)}}>编辑</el-button>]
							}
						}
					}
				]
			},
			list(page, updateForm, other) {
				return new Promise((resolve, reject) => {
					this.$api.compensation.list({
						...page,
						...updateForm,
						...other,
						...this.foreingKey
					}).then((res) => {
						this.amount = res.amount ? parseFloat(res.amount) : 0
						this.ordernum = res.ordernum ? parseFloat(res.ordernum) : 0
						this.groupbywarehouse = res.groupbywarehouse
						this.$refs.chart.data = res.chartdata
						this.$refs.chart.createChart()
						resolve(res)
					}, () => {
						reject()
					})
				})
			},
			static(){
				this.$refs.compensationStatistics.modal_show()
			},
			edit(row){
				this.currentrow = row
				this.$refs.reasonForm.modal_show()
			},
			editSuccess(){
				this.customreload()
			},
			customreload(){
				this.$refs.compensation_list.commitProxy('query')
			}
		},
		components: {
			chart,
			statistics,
			reasonForm
		}
	}
</script>